import React from 'react';
import { render } from 'react-dom';
import Application from './application/application';
//todo импорт для file-loader в webpack, иначе он про этот файл не знает. надо сделать по-нормальному
import bgImage from '../static/images/bg.jpg'

render(<Application />, document.getElementsByClassName('api-root')[0]);



// WEBPACK FOOTER //
// ./src/index.js